<div class="ui-g ui-fluid dashboard">
  <div class="ui-g ui-g-12">

    <div class="ui-g ui-g-12 logo-row">
      <div class="ui-g-12 ui-md-6 ui-lg-4 logo-col">
        <div class="highlight-box">
          <div class="card card-full-width card-center">
            <img src="/assets/layout/images/{{ getCompanyId() }}.png" alt="" class="logo" width="100%">
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-12 ui-md-12 welcome-row">
      <div class="card clearfix welcome-container">
        <span class="welcome">{{ 'dashboard.welcome' | translate }} {{ getDisplayNameForWelcome() }}!</span>
      </div>
    </div>

    <div *ngFor="let indicator of indicators;let i=index;" class="ui-g-12 ui-md-6 ui-lg-4 indicator-row">
      <app-infobox [pointData]="indicator" [options]="{dynamic:true, decimal_value:0, unit_period_prec:'€'}"
                   *ngIf="(i==0)"></app-infobox>
      <app-infobox [pointData]="indicator" [options]="{dynamic:true, decimal_value:3, decimal_prec_value:3}"
                   *ngIf="(i==1)"></app-infobox>
      <app-infobox [pointData]="indicator" [options]="{decimal_value:2, decimal_prec_value:2, unit_period_prec:'€'}"
                   *ngIf="(i==2)"></app-infobox>
    </div>

  </div>

  <div class="ui-g ui-g-12 last-update-row" *ngIf="referencePeriod">
    <div class="last-update-container">
      <span class="last-update">{{ 'indicator.reference_period' | translate }}: {{ referencePeriod.data_inizio | date: 'dd/MM/yyyy' }} - {{ referencePeriod.data_fine | date: 'dd/MM/yyyy' }}</span>
    </div>
  </div>

</div>
<div style="position: absolute; bottom: 0px; right: 0px;">
  <p style="font-size: small; margin-right: 10px">v {{ version }}</p>
</div>




// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard.html